import { get, set } from "lodash";

export const validatePassword = (values, schema) =>
  schema
    .validate(values, { abortEarly: false })
    .then(() => {})
    .catch(
      (error: {
        inner: Array<{ path: string; message: string }>;
        name: string;
      }) => {
        if (error.name !== "ValidationError") {
          throw error;
        }

        return error.inner.reduce((errors, currentError) => {
          const errorPath = get(errors, currentError.path) as string;

          if (currentError.path !== "password") {
            return set(errors, currentError.path, currentError.message);
          }

          const newErrors =
            errorPath?.length > 0
              ? set(errors, currentError.path, [
                  currentError.message,
                  ...errorPath,
                ])
              : set(errors, currentError.path, [currentError.message]);

          return newErrors;
        }, {});
      }
    );
